import styled from '@emotion/styled'
import { Modal, Button } from 'antd'
import { useMemo } from 'react'

import errorIcon from '@/assets/stakeXwanError.png'
import successIcon from '@/assets/stakeXwanSuccess.png'
import { useLocalStorage } from '@/context/localstorage-context'

const XWANStatusModal = ({
  visible,
  status,
  type,
  onCancel,
}: {
  visible: boolean
  status: string
  type: string
  onCancel: () => void
}) => {
  const { theme } = useLocalStorage()
  const isdark = useMemo(() => theme === 'dark', [theme])

  const statusIcon = useMemo(() => {
    switch (status) {
      case 'error':
        return errorIcon
      default:
        return successIcon
    }
  }, [status])

  const statusTxt = useMemo(() => {
    switch (status) {
      case 'error':
        return `Your ${type} has failed. Please try again.`
      default:
        return `Your ${type} was successful!`
    }
  }, [status, type])

  return (
    <Modal
      maskClosable={true}
      closable={true}
      destroyOnClose={true}
      width={558}
      mask={true}
      open={visible}
      title={null}
      footer={null}
      onCancel={onCancel}
      centered
      className={`${isdark ? 'darkModal' : 'lightModal'} xwan-stake-modal`}
    >
      <StatusIcon src={statusIcon}></StatusIcon>
      <StatusTxtCon
        className={`${
          status === 'success' ? 'text-light-1222' : 'text-light-1111'
        }`}
      >
        {statusTxt}
      </StatusTxtCon>
      <ConfirmButton onClick={onCancel} className="bg-light-111 text-white">
        OK
      </ConfirmButton>
    </Modal>
  )
}

export default XWANStatusModal

const StatusIcon = styled.img`
  width: 16rem;
  height: 16rem;
  margin: 4.5rem auto;
  display: block !important;
`

const StatusTxtCon = styled.div`
  text-align: center;
  font-family: Inter;
  font-size: 1.6rem;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  margin-bottom: 2.4rem;
`

const ConfirmButton = styled(Button)`
  width: 100%;
  padding: 2rem 0;
  height: fit-content;
  border-radius: 1.6rem;
  font-family: Inter;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  border: none;
`
